import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { ParadropGameCoreService } from './para-drop-game-core.service';
import { ParadropGameSelectorComponent } from './para-drop-game-selector/para-drop-game-selector.component';

@NgModule({
  declarations: [ParadropGameSelectorComponent],
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
  providers: [ParadropGameCoreService],
  exports: [ParadropGameSelectorComponent],
})
export class ParadropGameCoreModule {}
